import type { ReactNode } from 'react'
import { StatusBar } from './StatusBar'
import { GlowLine } from './GlowLine'
import { ControlBar } from './ControlBar'
import { cn } from '@/lib/utils'

interface CockpitShellProps {
  children: ReactNode
  agentName?: string
  agentId?: string
  className?: string
}

export function CockpitShell({
  children,
  agentName,
  agentId,
  className,
}: CockpitShellProps) {
  return (
    <div className={cn('relative flex min-h-0 flex-1 flex-col bg-slate-950 text-slate-100', className)}>
      <StatusBar agentName={agentName} agentId={agentId} />
      <GlowLine />
      <div className="flex-1 min-h-0 overflow-hidden">
        {children}
      </div>
      <ControlBar />
    </div>
  )
}
